

















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { focus } from '@/directives';

@Component({
  directives: {
    focus,
    blur,
  },
})
export default class EditorTitle extends Vue {
  @Prop({ default: '' }) private value!: string;
  @Prop({ default: '' }) private placeholder!: string;

  private edit: boolean = false;
  private currentValue: string = this.value;

  @Watch('value')
  private updateCurrentValue(val: string) {
    this.currentValue = val;
  }

  private onEdit() {
    this.edit = true;
  }

  private onDone() {
    this.edit = false;
    this.$emit('change', this.currentValue);
  }

  private onCancel() {
    this.edit = false;
    this.currentValue = this.value;
  }
}
